import { SVGProps } from 'react'

/**
 * The glyphs the Get VIP Card board uses, exported from Figma.
 *
 * They are inline rather than files under `public/` so they take their colour
 * from the surrounding text and so work in both themes.
 */

export function UnlockIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.4568 8.15263H6.29045V5.25826C6.29045 4.21591 6.67467 3.24802 7.37907 2.5221C8.08348 1.79619 9.01658 1.396 10.0137 1.396C12.0629 1.396 13.7278 3.13634 13.7278 5.26757V5.90042C13.7278 6.28199 14.0389 6.59842 14.4139 6.59842C14.789 6.59842 15.1001 6.28199 15.1001 5.90042V5.26757C15.1001 2.36389 12.813 0 10.0137 0C8.65981 0 7.37907 0.549092 6.40938 1.5449C5.45798 2.54072 4.92739 3.86226 4.92739 5.26757V8.16194H4.57061C3.14351 8.15263 2 9.32527 2 10.7585V17.4034C2 18.8367 3.14351 20 4.55232 20H15.4477C16.8565 20 18 18.8367 18 17.4034V10.7585C18 9.32527 16.8565 8.16194 15.4477 8.16194L15.4568 8.15263ZM10.6907 14.0624V16.1936C10.6907 16.5752 10.3796 16.8916 10.0046 16.8916C9.6295 16.8916 9.31847 16.5752 9.31847 16.1936V14.0624C8.86106 13.8111 8.54088 13.3271 8.54088 12.7594C8.54088 11.9404 9.19954 11.2704 10.0046 11.2704C10.8096 11.2704 11.4683 11.9404 11.4683 12.7594C11.4683 13.3271 11.1481 13.8111 10.6907 14.0624Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function MemberIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.09775 12.1621C1.32722 13.0941 0 14.5031 0 16.2436C0 18.1613 1.54161 20 3.57195 20H6.50254C6.53797 20 6.5734 19.9964 6.60792 19.9909H16.409C18.4075 19.9909 20 18.2794 20 16.3272C20 14.5912 18.6773 13.1604 16.9077 12.2066C16.0892 11.7651 15.139 11.4026 14.0961 11.1383C12.8416 10.8212 11.4535 10.6459 10 10.6459C7.34284 10.6459 4.90007 11.2128 3.09775 12.1621ZM9.30233 18.0049V16.0245H7.32195C7.12482 16.0245 6.94677 15.9428 6.81959 15.811C6.69876 15.6857 6.62427 15.5149 6.62427 15.3269C6.62427 15.1779 6.6706 15.0398 6.75055 14.9262C6.87682 14.7464 7.08576 14.6292 7.32195 14.6292H9.30233V12.6497C9.30233 12.2645 9.61483 11.952 10 11.952C10.1081 11.952 10.2098 11.9766 10.3007 12.0202C10.5351 12.1328 10.6977 12.3726 10.6977 12.6497V14.6292H12.6799C12.8961 14.6292 13.0896 14.7273 13.2177 14.8817C13.3176 15.0025 13.3775 15.1579 13.3775 15.3269C13.3775 15.712 13.065 16.0245 12.6799 16.0245H10.6977V18.0049C10.6977 18.3901 10.3852 18.7026 10 18.7026C9.61483 18.7026 9.30233 18.3901 9.30233 18.0049Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 9.16788C12.5325 9.16788 14.5867 7.11598 14.5867 4.58394C14.5866 2.05195 12.5324 0 10 0C7.46771 0.000157175 5.41431 2.05205 5.41424 4.58394C5.41424 7.11589 7.46767 9.16772 10 9.16788Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function QualifyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C15.5227 20 20 15.5229 20 10C20 4.47713 15.5227 0 10 0C4.47727 0 0 4.47713 0 10C0 15.5229 4.47727 20 10 20ZM10.7606 5.2341L11.7136 7.12938C11.8373 7.37508 12.076 7.54537 12.3522 7.5847L14.4835 7.88866C15.1793 7.98787 15.4571 8.82684 14.9536 9.3084L13.4115 10.7837C13.2115 10.9749 13.1204 11.2505 13.1676 11.5205L13.5316 13.6036C13.6504 14.2836 12.9232 14.8021 12.3009 14.4811L10.3947 13.4975C10.1476 13.3701 9.85243 13.3701 9.60531 13.4975L7.69911 14.4811C7.07682 14.8021 6.34956 14.2836 6.46837 13.6036L6.83241 11.5205C6.85357 11.4001 6.84706 11.2787 6.81559 11.1641C6.77653 11.0216 6.69922 10.8897 6.58854 10.7837L5.04639 9.3084C4.54291 8.82684 4.82069 7.98787 5.51622 7.88866L7.64757 7.5847C7.92399 7.54537 8.16271 7.37508 8.28613 7.12938L9.23937 5.2341C9.55051 4.61541 10.4495 4.61541 10.7606 5.2341Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function CheckCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 21.5 21.5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.33824 10.3853L9.52647 13.5735L15.1618 7.92644M20.75 10.75C20.75 16.2728 16.2728 20.75 10.75 20.75C5.22715 20.75 0.75 16.2728 0.75 10.75C0.75 5.22715 5.22715 0.75 10.75 0.75C16.2728 0.75 20.75 5.22715 20.75 10.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
